import React from 'react'
import './GetStarted.css'
import { useNavigate } from 'react-router-dom'


const GetStarted = () => {
  const navigate = useNavigate()

  const sendToContact = () => {
    navigate('/contact-us', { replace: true })
  }
  return (
    <div className="started-bg">
      <div className="started-box">
        <h1>Ready to Get Started?</h1>
        <h3>
          We are here to help! Tangled Lead will promptly answer your requests
          and provide trustworthy and reliable service. Please don't hesitate to
          reach out.
        </h3>
        <div className="contact-btn-container">
          <button onClick={sendToContact} className="contact-us-btn">
            Contact Us
          </button>
        </div>
      </div>
    </div>
  )
}

export default GetStarted




